
import React, { useEffect, useState, useRef } from "react";
import DateWise_StockdetailsSchemeWise from "./DateWise_StockdetailsSchemeWise";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import PaginationTable from "../../pagination/Pagination4";

const fetchTransactionData = async (params) => {
  //console.log("Fetching with params:", JSON.stringify(params));

  const response = await fetch(
    `${process.env.REACT_APP_URL_FPS}/fps/DateWiseStockDetails`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch transaction data");
  }

  const data = await response.json();
  return data;
};

const DetailedTransaction = ({ month, year, fps_id, pos_ob_date }) => {
  const [dateWiseList, setDateWiseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchQuery, setSearchQuery] = useState("");
  const [renderContent, setRenderContent] = useState(null);

  const detailsRef = useRef(null);

  //  Correct parameter order
  const handleDistClick = (month, year, comm_id, pos_ob_date, fps_id) => {
    setRenderContent(null);
    setTimeout(() => {
      setRenderContent(
        <DateWise_StockdetailsSchemeWise
          month={month}
          year={year}
          comm_id={comm_id}
          pos_ob_date={pos_ob_date}
          fps_id={fps_id}
        />
      );
    }, 10);
  };

  //  Fetch data
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const params = { month, year, fps_id, pos_ob_date };

      try {
        const response_data = await fetchTransactionData(params);
      //  console.log("Response Data:", response_data);

        setTabHeading(response_data?.heading || "");
        setDateWiseList(response_data?.data || []);
      } catch (err) {
        //console.error("Error fetching data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year, fps_id, pos_ob_date]);

  //  Scroll into view when data loads
  useEffect(() => {
    if (!loading && !error && dateWiseList.length > 0 && detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [loading, error, dateWiseList]);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === "all" ? dateWiseList.length : parseInt(value, 10));
    setPage(0);
  };

  const filteredData = dateWiseList.filter((item) =>
    item.fps_id?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const paginatedData =
    rowsPerPage === "all"
      ? filteredData
      : filteredData.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        );

  // Loading state
  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
      >
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  //  Error state
  if (error) {
    return (
      <div className="mainhead" align="center">
        Internal Error
      </div>
    );
  }

  //  Empty data
  if (dateWiseList.length === 0) {
    return (
      <div className="mainhead" align="center">
        No data found
      </div>
    );
  }

  // Main rendering
  return (
    <>
      <br />
      <table align="center" width="80%" border={1}>
        <thead>
          <tr className="tableheader">
            <th colSpan={9}>{tabHeading}</th>
          </tr>
          <tr className="tableheader">
            <th>Sl.No</th>
            <th>Commodity</th>
            <th>Units</th>
            <th>OB Qty  <br /><span className="styleDF">(A) </span> </th>
            <th>Received Qty <br /><span className="styleDF">(B)</span>  </th>
            <th>Extra <br /><span className="styleDF">(C)</span> </th>

            <th>Moved <br /><span className="styleDF">(D)</span> </th>
            <th>Issued Qty <br /><span className="styleDF">(E)</span>  </th>
            <th>CB Qty <br /><span className="styleDF"> (A+B+C+D-E)   </span> </th>
          </tr>
        </thead>

        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={`${item.fps_id}-${index}`}>
              <td style={{ textAlign: "center" }}>
                {rowsPerPage === "all"
                  ? index + 1
                  : index + 1 + page * rowsPerPage}
              </td>

              <td style={{ textAlign: "left" }}>
                <a
                  style={{ cursor: "pointer", color: "blue" }}
                  onClick={() =>
                    handleDistClick(month, year, item.comm_id, pos_ob_date, fps_id)
                  }
                >
                  {item.comm_name_en}
                </a>
              </td>

              <td style={{ textAlign: "left" }}>{item.comm_measure_unit}</td>
              <td style={{ textAlign: "right" }}>{item.ob}</td>
              <td style={{ textAlign: "right" }}>{item.received_qty}</td>
                            <td style={{ textAlign: "right" }}>{item.extra_ro}</td>

              <td style={{ textAlign: "right" }}>{item.sixa_case}</td>
              <td style={{ textAlign: "right" }}>{item.issued_qty}</td>
              <td style={{ textAlign: "right" }}>{item.cb}</td>
            </tr>
          ))}


            <tr className="tableheader">
                        <td colSpan={17} style={{ textAlign: 'right' }}>
                            Data Time:
                            <font style={{color:'red'}}> 
                                 {dateWiseList[0]?.data_time?.substring(0, 16)}
                                 </font>
                        </td>
                    </tr>

          {/* Totals Row */}
          {/* <tr className="tableheader">
            <td colSpan={2} style={{ textAlign: "center" }}>
              Total
            </td>
            <td colSpan={7}></td>
          </tr> */}
        </tbody>
      </table>

      <br /> <br></br>

      {/* Pagination section */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "90%",
          margin: "20px auto",
        }}
      >
        <PaginationTable
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div> */}

      <div ref={detailsRef}>{renderContent}</div>
    </>
  );
};

export default DetailedTransaction;
